<p>mobile-home-view works!</p>
